export default __webpack_public_path__ + "static/media/9.4fb3cef4.png";